import { Box, Heading, HStack } from "@chakra-ui/react"
import { Granularity } from "@hydrologiq/common/types/reporting/Granularity"
import ReportPreview from "./ReportPreview"

import { DateTime } from "timezonecomplete"
import { RowType as RowTypes } from "./rows"
import { DownloadCSVButton } from "../content/components/Button"
import { ReactNode } from "react"

export type OnDataCallback<RowType> = () => RowType[]

interface ReportingProps<RowType extends RowTypes> {
  start: DateTime
  end: DateTime
  granularity: Granularity
  children: React.ReactNode

  onDataCallback: OnDataCallback<RowType>
  onDownload: () => void
  downloading: boolean
  loading?: boolean
  visibleFields?: (keyof RowTypes)[]
  fieldSelector?: ReactNode
}

export function ReportingSkeleton({
  download,
  preview,
  downloading,
  fieldSelector,
}: {
  download?: ReactNode
  preview?: ReactNode
  downloading?: ReactNode
  fieldSelector?: ReactNode
}) {
  return (
    <Box pb={10}>
      <HStack justifyContent={"space-between"}>
        <Heading as="h3" size={"md"}>
          Results (first 10 items)
        </Heading>
        <HStack gap={2}>
          {fieldSelector}
          {download ? download : <DownloadCSVButton disabled={true} width="fit-content" />}
        </HStack>
      </HStack>
      {preview ? preview : <ReportPreview rows={[]} loading={true} />}
      {downloading ? downloading : null}
    </Box>
  )
}

function Reporting<RowType extends RowTypes>({
  onDataCallback,
  children,
  onDownload,
  downloading,
  loading,
  visibleFields,
  fieldSelector,
}: ReportingProps<RowType>) {
  return (
    <ReportingSkeleton
      download={<DownloadCSVButton disabled={loading} width="fit-content" onClick={onDownload} />}
      preview={<ReportPreview rows={onDataCallback()} loading={loading} visibleFields={visibleFields} />}
      downloading={downloading && children}
      fieldSelector={fieldSelector}
    />
  )
}

export default Reporting
